import React, { useEffect } from "react";
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from "antd";

const LoaderData = ({ size = 'small', showLoad = true, fixed = false }) => {

    return (
        <>
            {
                showLoad ?
                    <div className={fixed ? 'fixed-loader' : ''}>
                        <Spin
                            fullscreen
                            indicator={
                                <LoadingOutlined
                                    style={{
                                        fontSize: 48,
                                    }}
                                    spin
                                />
                            }
                        />
                    </div> : <></>
            }
        </>
    );

}
export default LoaderData;